'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useAppliedTheme } from '@/hooks/ui/use-applied-theme';
import { cn } from '@/lib/ui/utils';
import { LOGO_SRC_DARK_BACKGROUND, LOGO_SRC_LIGHT_BACKGROUND, logoWordmarkWidthForHeight, O_MARK_SRC_DARK_BACKGROUND, O_MARK_SRC_LIGHT_BACKGROUND } from './constants';
const DEFAULT_LOGO_HEIGHT_PX = 64;
interface MorfiLogoProps {
  /** Logo height in pixels. Width follows the active asset aspect ratio. Default 64. */
  size?: number;
  mark?: boolean;
  className?: string;
}
function resolveLogoSrc(theme: 'light' | 'dark' | undefined, mark: boolean): string {
  if (mark) {
    return theme === 'dark' ? O_MARK_SRC_DARK_BACKGROUND : O_MARK_SRC_LIGHT_BACKGROUND;
  }
  return theme === 'dark' ? LOGO_SRC_DARK_BACKGROUND : LOGO_SRC_LIGHT_BACKGROUND;
}
export function MorfiLogo(t0) {
  const $ = _c(13);
  const {
    size: t1,
    mark: t2,
    className
  } = t0;
  const size = t1 === undefined ? DEFAULT_LOGO_HEIGHT_PX : t1;
  const mark = t2 === undefined ? false : t2;
  const theme = useAppliedTheme();
  const height = size;
  let t3;
  if ($[0] !== mark || $[1] !== size) {
    t3 = mark ? size : logoWordmarkWidthForHeight(size);
    $[0] = mark;
    $[1] = size;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const width = t3;
  let t4;
  if ($[3] !== mark || $[4] !== theme) {
    t4 = resolveLogoSrc(theme, mark);
    $[3] = mark;
    $[4] = theme;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const src = t4;
  let t5;
  if ($[6] !== className) {
    t5 = cn("block shrink-0 object-contain", className);
    $[6] = className;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== height || $[9] !== src || $[10] !== t5 || $[11] !== width) {
    t6 = <Image src={src} alt="Morfi" width={width} height={height} className={t5} />;
    $[8] = height;
    $[9] = src;
    $[10] = t5;
    $[11] = width;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}